import React, { useEffect, useState } from 'react';
import { createAuth0Client } from '@auth0/auth0-spa-js';

export const AUTHENTICATION_TOKEN = 'authentication_token';

export default function Auth0Redirect({ auth0Config, title, destination }) {

  const [error, setError] = useState(null);

  useEffect(() => {

    const redirectToDestination = () => {
      window.location.href = destination;
    };

    const initAuth0 = async () => {
      try {
        // todo pull into hook
        const auth0Client = await createAuth0Client({
          domain: auth0Config.domain,
          clientId: auth0Config.clientId,
          authorizationParams: {
            redirect_uri: auth0Config.redirectUri,
            scope: 'openid profile email',
            audience: auth0Config.audience,
          },
        });

        try {
          const token = await auth0Client.getTokenSilently()
          localStorage.setItem(AUTHENTICATION_TOKEN, token)
          redirectToDestination()
        } catch (e) {
          console.error('Direct login failed, redirecting to Auth0 for login.', e);
          await auth0Client.loginWithRedirect({
            appState: { redirectPath: destination },
            authorizationParams: {
              connection: "email",
            },
          })
        }
      } catch (err) {
        console.error('Direct login error:', err);
        setError(err);
      }
    };

    initAuth0();
  }, [auth0Config.audience, auth0Config.clientId, auth0Config.domain, auth0Config.redirectUri, destination]);

  if (error) {
    return (
      <div>
        <h3>{title}</h3>
        <p>Error while logging in, redirecting to Auth0 for login.</p>
        <pre>{error.message}</pre>
      </div>
    );
  }

  return (
    <div>
      <h3>{title}</h3>
      <p>Logging into CJ...</p>
    </div>
  );
}
